import { zetApi } from '@zet/network'

import ENDPOINTS from '../../endpoints'

export async function calculateEMI({
  hash,
  amount,
  tenure,
}: {
  hash: string
  amount: number
  tenure: number
}) {
  const response = await zetApi.request({
    url: ENDPOINTS.calculateEMI.endpoint,
    method: ENDPOINTS.calculateEMI.method,
    headers: {
      hash: encodeURIComponent(hash),
    },
    data: {
      amount,
      tenure,
    },
  })

  return response.data
}
